import * as React from 'react';
import { FunctionComponent } from 'react';
import moment from 'moment';
import './GeneralMessagePreview.css';

interface Props {
  messageSmsText: string;
  showTitle?: boolean;
}

export const GeneralMessagePreviewSms: FunctionComponent<Props> = props => {
  const currentTime = moment(new Date()).format('HH:mm');

  return (
    <div className="gmPreviewSms gmPreviewSms--device">
      <div className="gmPreviewSms__statusBar">
        <span>{currentTime}</span>
        <span aria-hidden="true">● ))) ▰</span>
      </div>
      <div className="gmPreviewSms__contact">
        <span className="gmPreviewSms__back" aria-hidden="true">‹</span>
        <span className="gmPreviewSms__contactAvatar">S</span>
        <span className="gmPreviewSms__sender">Squad In Touch</span>
        <span className="gmPreviewSms__contactChevron" aria-hidden="true">›</span>
      </div>
      <div className="gmPreviewSms__conversation">
        <div className="gmPreviewSms__day">Today {currentTime}</div>
        <div className="gmPreviewSms__bubble">{props.messageSmsText || 'No SMS content yet.'}</div>
      </div>
      <div className="gmPreviewSms__composer" aria-hidden="true">
        <span>＋</span>
        <span className="gmPreviewSms__composerField">Text Message</span>
        <span>↑</span>
      </div>
    </div>
  );
};
